import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./CustomToastStyles.css";
import Header from "./Header.js";
import Sidebar from "./Sidebar.js";
import Footer from "./Footer.js";
import { token } from "./Constants.js";
//import { BASE_URL } from "./Constants.js";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const ResetPassword = () => {
	const { id } = useParams();
    const [EmpCode, setEmpCode] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
	const [formData, setFormData] = useState({
		name: "",
		status: "",
		id: id, // Use the id from params
	});
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");
	const navigate = useNavigate();
	const validateFormData = () => {
		
		return true;
	};

	const handleChange = e => {
		const { name, value } = e.target;
		setFormData(prevState => ({
			...prevState,
			[name]: value, // Adjust to set value correctly
		}));
	};

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const token = localStorage.getItem('authToken');
				console.log("token1",token);
                const response = await fetch(`${API_BASE_URL}users?emp_code=${id}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
						 'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
				
                console.log("Profile data1:", result);

                if (result.status) {
                    setEmpCode(result.user.emp_code || '');
                    const report_mngr = result.user.report_mngr || ''; 
                    setFormData({
                        comp_name: result.user.comp_name || '',
                        password: result.user.password || '',
                        emp_code: result.user.emp_code || '',
                        dept_name: result.user.dept_name || '',
                        designation_name: result.user.designation_name || '',
                        grade: result.user.grade || '',
                        is_manager_approval	: result.user.is_manager_approval	 || '',
                        is_audit_approval	: result.user.is_audit_approval	 || '',
                        is_finance_approval	: result.user.is_finance_approval	 || '',
                        travel_advance: result.user.travel_advance || '',
                        travel_advance_amount: result.user.travel_advance_amount || '',
                        bank_details: result.user.bank_details || '',
                        days: result.user.days || '',
                        city: result.user.city || '',
                        purpose: result.user.purpose || '',
                        mode_of_travel: result.user.mode_of_travel || '',
                        mobile: result.user.mobile || '',
                        report_mngr:    report_mngr,
                        // Do not display the password
                        hotel_tickets: result.user.hotel_tickets || '',
                        travel_tickets: result.user.travel_tickets || '',
                       // to_city: result.profile.to_city || '',
                    });
                    
                  
                } else {
                    setResponseMessage('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            }
        };
      
        fetchProfileData();
    }, []);

	const handleSubmit = async e => {
		e.preventDefault();
		if (!validateFormData()) return; // Ensure validation

		const formDataToSubmit = new FormData();
		formDataToSubmit.append('is_manager_approval', formData.is_manager_approval);
    formDataToSubmit.append('is_finance_approval', formData.is_finance_approval);
    formDataToSubmit.append('is_audit_approval', formData.is_audit_approval);

		try {
            const token = localStorage.getItem('authToken');
			const response = await fetch(`${API_BASE_URL}editEmployee/${EmpCode}`, {
				method: "PUT",
				headers: {
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify({
                    is_manager_approval: formData.is_manager_approval,
                    is_audit_approval: formData.is_audit_approval,
                    is_finance_approval: formData.is_finance_approval,
                }),
			});

			const result = await response.json();
			if (result.status) {
				toast.success("State successfully updated");
				navigate("/manage_employee");
			} else {
				toast.error(
					result.message || "An error occurred while updating the state.",
				);
			}
		} catch (error) {
			console.error("Fetch error:", error);
			toast.error("Failed to submit form");
		}
	};

	useEffect(() => {
		const fetchState = async () => {
			try {
				const formData = new URLSearchParams();
				formData.append("id", id);
				const response = await fetch(`${API_BASE_URL}getStateDetails`, {
					method: "POST",
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/x-www-form-urlencoded",
					},
					body: formData.toString(),
				});
				const result = await response.json();
				if (result.state) {
					setFormData({
						name: result.state.name,
						status: result.state.status,
						id: id,
					});
				} else {
					setError("No state data found.");
				}
			} catch (error) {
				console.error("Fetch error:", error);
				setError("Failed to get State details");
			}
			setLoading(false);
		};
		fetchState();
	}, [id]);

	return (
		<div className='hold-transition sidebar-mini layout-fixed'>
			<div className='wrapper'>
				<Header />
				<Sidebar />
				<div className='content-wrapper'>
					<div className='content-header'>
						<div className='container-fluid'>
							<div className='row mb-2'>
								<div className='col-sm-6'>
									<h1 className='m-0'>Reset Password</h1>
								</div>
								<div className='col-sm-6'>
									<ol className='breadcrumb float-sm-right'>
										<li className='breadcrumb-item'>
											<a href='#'>Home</a>
										</li>
										<li className='breadcrumb-item active'>Reset Password</li>
									</ol>
								</div>
							</div>
						</div>
					</div>

					<section className='col-lg-12'>
						<div
							className='card'
							style={{ borderTop: "3px solid #00c0ef" }}>
							<div className='box box-info'>
								<div className='card-header'>
									<h3 className='card-title'>Reset Password</h3>
								</div>

								<div className='card-body'>
									<form onSubmit={handleSubmit}>
										<div className='box-body'>
											<div className='row'>
												<div className='col-md-4'>
													<div className='form-group'>
														<label htmlFor='name' style={{ fontSize: '12px' }}>
                                                        Employee Password<span style={{ color: "red" }}>*</span>
														</label>
														<input
															type='text'
															name='name'
															value={formData.password}
															onChange={handleChange}
															className='form-control  input-font'
															disabled
														/>
													</div>
												</div>

												
											</div>
                                            
										</div>

										<div className='box-footer'>
											<button
												type='submit'
												className='btn btn-success pull-right'>
												Submit
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</section>
				</div>

				<Footer />
				<ToastContainer />
			</div>
		</div>
	);
};

export default ResetPassword;
